export const environment = {
  production: false,
  apiUrl: '/kf-platform-api/',
  cognitoLoginEnabled: false,
  cognitoUserPoolId: '',
  cognitoAppClientId: '',
  hideCharts: false
};